import { Icon, Tooltip } from '@blueprintjs/core';
import styles from './ValueWarning.module.css';

type IValueWarning = {
  value: string;
  content: string;
  isInvalid?: boolean;
};

export function ValueWarning({ value, content, isInvalid }: IValueWarning) {
  return (
    <>
      <span className={isInvalid ? styles.danger : styles.warning}>
        {value}
      </span>
      <Tooltip content={content} className={styles.tooltip}>
        <Icon
          icon="warning-sign"
          size={12}
          className={isInvalid ? styles.danger : styles.warning}
          data-testid={'warning-icon'}
        />
      </Tooltip>
    </>
  );
}
